import { useEffect, useRef } from 'react';
import { useSocket } from './useSocket';

export type BoardScope = 'orders' | 'acts' | 'employees' | 'settings' | 'media' | 'requests' | 'counterparties' | 'kb' | 'prices' | 'maintenance' | 'crews';

// Подписка на сигнал "что-то поменялось" с бэкенда (см. NotificationsGateway.broadcastBoardUpdate) —
// вызывает onUpdate, когда наряд/акт/сотрудник изменился где угодно (в т.ч. со стороны техника
// или Битрикса), чтобы экран сам обновил данные без перезагрузки страницы
export function useBoardUpdates(scopes: BoardScope[], onUpdate: () => void) {
  const socket = useSocket('notifications');

  // scopes/onUpdate обычно приходят новыми на каждый рендер (инлайн-массив, инлайн-функция) —
  // держим их в ref, чтобы подписка на сокет не пересоздавалась и при этом обработчик всегда
  // видел актуальные filter/orderId, а не те, что были на момент подключения сокета
  const scopesRef = useRef(scopes);
  scopesRef.current = scopes;
  const onUpdateRef = useRef(onUpdate);
  onUpdateRef.current = onUpdate;

  useEffect(() => {
    if (!socket) return;
    const handler = (payload: { scope: string }) => {
      if (scopesRef.current.includes(payload.scope as BoardScope)) {
        onUpdateRef.current();
      }
    };
    socket.on('board:update', handler);
    return () => {
      socket.off('board:update', handler);
    };
  }, [socket]);
}
